import { useState, useEffect, useRef, Fragment } from 'react'
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

// import Backdrop from '../../Backdrop/Backdrop';
import Loader from '../../Loader/Loader';
// import Modal from '../../Modal/Modal';
// import VoiceGenerator2Socket from '../VoiceGenerator2Socket';

import { useStore } from '../../../hook-store/store';
import { 
  generateTextAudio, 
} from '../../../utils/voice-generator2-utils/voice-generator2-utils'

import { 
  TEXTAUDIOTOOLSNODE_URL,
  signupPageLink,
  loginPageLink,
 } from '../../../App';

import { marks } from '../../../utils/marks';
import '../VoiceGenerator2.css';


function VoiceGeneratorAction(props) {

  const { 
    speakerId,
    ttsGenLng,
    ttsGenModels,
    ttsGenRepoId,
    textInput,
    genSpeed,
    generatedAudioFiles,
    setGeneratedAudioFiles,
    isModelLoading,
    ttsGenMaxText,
    ttsGenFreeMaxText,
    textToSpeechConfig,
    isLoading,
    setIsLoading,
  } = props;

  const [t] = useTranslation("translation");

  // const hiddenFileSelect = useRef(null);

  const [store, dispatch] = useStore();
  const { 
    textToSpeechApiExist,
    isVoiceGenerating,
  } = store.mlVoiceStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
    usageBasedValidMethod,
    usageBasedConfig,
  } = store.stripeData;
  const { 
    isAuth, 
  } = store.uiStore;

  const [isUserGenerating, setIsUserGenerating] = useState(false);

  const generateAudioHandler = async () => {
    // const generateBtn = document.getElementById('tts-generateBtn');
    // generateBtn.click();
    try {

      setIsLoading(true);
      setIsUserGenerating(true);
      dispatch('CLEAR_NOTIFICATION');

      let sId = speakerId;

      if (!speakerId) {
        sId = '0';
      }

      // throw new Error('error-error')
      let usageBasedPriceId = '';

      if (usageBasedPrice) {
        usageBasedPriceId = usageBasedPrice.id;
      }
      const audioFileData = await generateTextAudio(
        TEXTAUDIOTOOLSNODE_URL,
        localStorage.getItem('token'),
        ttsGenLng,
        ttsGenRepoId,
        textInput,
        sId,
        genSpeed,
        localStorage.getItem('customerId'),
        usageBasedPriceId,
        localStorage.getItem('userId'),
      );

      if (audioFileData) {
        const modelDisplayName = createModelDisplayName(
          ttsGenModels, 
          ttsGenLng,
          ttsGenRepoId,
        );
        
        const addedList = [
          {
            ...audioFileData,
            modelDisplayName: modelDisplayName,
          }
        ].concat(generatedAudioFiles)

        // console.log('addedList', addedList)
        setGeneratedAudioFiles(addedList.slice(0,5));

        dispatch('SHOW_NOTIFICATION', {
          status: '',
          title: 'audio generated',
          message: '',
        });
  
        setTimeout(() => {
          dispatch('CLEAR_NOTIFICATION');
        },1000 * 10);
      }

      setIsLoading(false);

      //// for disabling generation button
      let genAfterTime = 15000;
      
      if (textInput.length > 150) {
        genAfterTime = 30000;
      }

      setTimeout(() => {
        // setIsLoading(false);
        setIsUserGenerating(false);
      }, genAfterTime)

    } catch(err) {
      setIsLoading(false);
      setIsUserGenerating(false);
      console.log(err);

      dispatch('SHOW_NOTIFICATION', {
        status: 'error',
        title: 'audio generation failed',
        message: '',
      });
      // throw err;
    }
  };



  const createModelDisplayName = (ttsGenModels, ttsGenLng, ttsGenRepoId) => {
    let modelDisplayName = '';

    if (ttsGenModels && ttsGenModels.length > 0 && ttsGenLng) {
      const selectedModelData = ttsGenModels.find(model => {
        return model.code === ttsGenLng;
      })
  
      if (selectedModelData) {
      
        if (ttsGenRepoId) {
          const repoIndex = selectedModelData.models.indexOf(ttsGenRepoId);
          const modelDesc = ttsGenRepoId.split('/')[1].split('|')[0];

          modelDisplayName = `${selectedModelData.name} - ${repoIndex + 1} (${modelDesc})`;
        }
      }
    }

    return modelDisplayName;

  };


  // let selectedLngModels = [];
  let genButtonDisabled = false;
  let genButtonText = `${t('voiceGenerator07', 'Generate audio')}`;
  // let numberOfSpeakerId = 1;



  if (isModelLoading || isLoading || !ttsGenLng || !ttsGenRepoId || !textInput) {
    genButtonDisabled = true;
  }

  if (!textToSpeechApiExist || isVoiceGenerating || isUserGenerating) {
    genButtonDisabled = true;
    genButtonText = `${t('voiceGenerator08', 'Busy...')}`
  }

  if (textInput && textInput.length > ttsGenMaxText) {
    genButtonDisabled = true;
  }


  let isUsageBased = false;
  let isUsageBasedOk = true;
  let ubbUnit = 0;

  if (textInput.length > ttsGenFreeMaxText) {
    isUsageBased = true;

    if (usageBasedConfig && textToSpeechConfig) {
      ubbUnit = usageBasedConfig.textToSpeechUnit;
  
      if (textInput.length > textToSpeechConfig.tts1xMaxLength && 
          textInput.length <= textToSpeechConfig.tts2xMaxLength
      ) {
        ubbUnit = Number( (ubbUnit*2).toFixed(0) );
      }
    }

  }

  if (isUsageBased && 
      (!isAuth || !usageBasedSubscription || !usageBasedValidMethod)
  ) {
    isUsageBasedOk = false;
    genButtonDisabled = true;
  }

  console.log(isUsageBased, isUsageBasedOk);


  let voiceGeneratorActionBody;

  voiceGeneratorActionBody = (
    <div>
        {/* {textInput.length > ttsGenFreeMaxText && (
          <div>more-than-free-text</div>
        )} */}

        {/* tts-config: {JSON.stringify(textToSpeechConfig)}

        <div>
          ubb-config: {JSON.stringify(usageBasedConfig)}
        </div> */}
        {ubbUnit > 0 && (
          <div className='voiceGenerator2Section'>
            Unit{' '}
            <strong>
              {ubbUnit}
              {' '}
              ({Number(usageBasedPrice.unit_amount_decimal)/100*usageBasedConfig.textToSpeechUnit} USD)
            </strong>
          </div>
        )}

        {isUsageBased && !isAuth && (
          <div>
            <div className='voiceGenerator2Section'>
              <strong>
                {t('voiceGenerator18', 'For longer text, User need to enable usage based billing after login.')}
              </strong>
            </div>
            <div className='voiceGenerator2Section'>
              <a href={loginPageLink}>
                <button className="btnBase">
                  {marks.signInMrak} {t('aboutAuth06', 'Login')}
                </button>
              </a>
              <span> or </span>
              <a href={signupPageLink}>
                <button className="btnBase">
                  {marks.userPlusMrak} {t('aboutAuth07', 'Signup')}
                </button>
              </a>
            </div>
          </div>
        )}

        {isUsageBased && isAuth && !usageBasedSubscription && (
          <div className='voiceGenerator2Section'>
            <div>
              <strong>
                {t('voiceGenerator19', 'Enabling usage based billing is required.')}
              </strong>
            </div>
            <Link
              to="/usage-based-billing"
            >
              <button className='btnBase'>
                {t('voiceGenerator20', 'Go to usage based billing page')}
              </button>
            </Link>
          </div>
        )}

        {isUsageBased && isAuth && usageBasedSubscription && !usageBasedValidMethod && (
          <div className='voiceGenerator2Section'>
            <div>
              <strong>
                {t('voiceGenerator21', 'Card information for payment is required.')}
              </strong>
            </div>
            <Link
              to="/usage-based-billing"
            >
              <button className='btnBase'>
                {t('voiceGenerator20', 'Go to usage based billing page')}
              </button>
            </Link>
          </div>
        )}

        <div className='voiceGenerator2Section'>
          <button className='btnBase'
            style={{ 
              padding: "0.75rem", 
              fontSize: "1.25rem", 
              fontWeight: "bold",
              color: genButtonDisabled ? 'gray' : 'inherit',
            }}
            disabled={genButtonDisabled || !isUsageBasedOk}
            onClick={generateAudioHandler}
          >
            {genButtonText}
          </button>
          {isLoading && ( <Loader />)}

          {/* {isVoiceGenerating && (
            <div>busy...</div>
          )} */}
        </div>
    </div>
  );


  return (
    <Fragment>
      {/* {!textToSpeechApiExist && (
        <div>not-api-exist</div>
      )} */}
      <div>
        {voiceGeneratorActionBody}
      </div>
    </Fragment>
  )
}

export default VoiceGeneratorAction;
